<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="10"
      :loading="loading"
      :search="search"
      :sort-by="sort"
      :sort-desc="sortDesc"
      :show-expand="expand"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat dark>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            class="mb-2"
            v-if="canExport"
            @click="exportTable()"
            color="primary darken-2"
            >Export</v-btn
          >
          <v-dialog v-model="dialog" max-width="500px" v-if="add">
            <template v-slot:activator="{ on }">
              <v-btn class="mb-2" v-on="on" color="primary darken-2"
                >Add {{ titleSingle }}</v-btn
              >
            </template>
            <v-card>
              <v-toolbar flat dark>
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
              </v-toolbar>

              <v-card-text>
                <slot></slot>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog = false">Cancel</v-btn>
                <v-btn text @click="saveItem">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.deleteItem="{ item }">
        <v-icon small class="mr-2" @click="viewItem(item)">mdi-download</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.downloadItem="{ item }">
        <v-icon small class="mr-2" @click="viewItem(item)">mdi-download</v-icon>
      </template>
      <template v-slot:item.actionOverview="{ item }">
        <v-icon small class="mr-2" @click="viewItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.date="{ item }">
        <div v-if="item.date">
          {{ item.date | formatDate }}
        </div>
      </template>
      <template v-slot:item.validUntil="{ item }">
        <div v-if="item.validUntil">
          {{ item.validUntil | formatDate }}
        </div>
        <div v-else>
          Failed
        </div>
      </template>
      <!-- Test Results -->
      <template v-slot:item.passedGeneral="{ item }">
        <div v-if="item.passedGeneral">
          <v-icon small color="green">mdi-checkbox-marked-circle</v-icon>
          Pass
        </div>
        <div v-else-if="item.passedGeneral == null">
          <v-icon small color="grey">mdi-help-circle</v-icon>
          Incomplete
        </div>
        <div v-else>
          <v-icon small color="red">mdi-alert-circle</v-icon>
          Fail
        </div>
      </template>
      <!-- Test Results end -->
    </v-data-table>
  </div>
</template>

<script>
export default {
  components: {},
  name: "BaseTable",
  props: {
    title: String,
    titleSingle: String,
    headers: Array,
    items: Array,
    valid: Boolean,
    loading: Boolean,
    add: Boolean,
    canExport: Boolean,
    sort: String,
    sortDesc: Boolean,
    expand: Boolean
  },
  data() {
    return {
      dialog: false,
      editedIndex: -1,
      search: ""
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New " + this.titleSingle
        : "Edit " + this.titleSingle;
    }
  },
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      this.$emit("get-items");
    },
    saveItem() {
      if (this.editedIndex > -1) {
        this.$emit("put-item");
      } else {
        this.$emit("post-item");
      }

      if (this.valid) this.dialog = false;
    },
    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.$emit("edit-item", item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        this.$emit("delete-item", item);
      }
    },
    viewItem(item) {
      this.$emit("view-item", item);
    },
    exportTable() {
      this.$emit("export");
    }
  },
  watch: {
    dialog: function() {
      if (this.dialog) {
        this.$emit("modal-open");
      } else {
        setTimeout(() => {
          this.$emit("modal-close");
          this.editedIndex = -1;
        }, 300);
      }
    }
  }
};
</script>

<style scoped></style>
